import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import Field from './Field';

import './TextField.scss';



export default function TextField({ style, label, value, onChange, error, classes, ...props }) {
  return (
    <Field
      style={style}
      className={classes+" form-text-field"}
      label={label}
      value={value}
      error={error}
    >
      {(onFocus, onBlur) => {
        return (
          <NumberFormat
            value={value}
            onValueChange={(v) => {
              onChange({ target: { value: v.value } });
            }}
            onFocus={onFocus}
            onBlur={() => {
              onBlur(value);
            }}
            {...props}
          />
        );
      }}
    </Field>
  );
}

TextField.propTypes = {
  style: PropTypes.shape(),
  label: PropTypes.string,
  value: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.node,
};

TextField.defaultProps = {
  style: {},
  label: '',
  value: '',
  error: null,
};
